import { useMutation } from "react-query";
import { checkTeamMembersConflicts } from "../apis/workspace/teams";

export const useCheckTeamMembersConflicts = ({ onSuccess, onError } = {}) => {
  return useMutation(
    async ({ workspaceId, data, teamId, teamMembers, options } = {}) => {
      if (!workspaceId) {
        throw new Error("workspaceId is required to check team member conflicts.");
      }

      const requestBody =
        data ??
        {
          team_id: teamId ?? "",
          team_members: teamMembers ?? [],
        };

      const requestOptions = {
        ...(options ?? {}),
        headers: {
          "X-Workspace-Id": workspaceId,
          ...(options?.headers ?? {}),
        },
      };

      return checkTeamMembersConflicts({
        data: requestBody,
        options: requestOptions,
      });
    },
    {
      onSuccess,
      onError,
    }
  );
};
